import axios from 'axios';
import * as Sentry from '@sentry/react';

export default packetId =>
	axios
		.patch(
			'/jsonapi/node/packet/' + packetId,
			{
				data: {
					type: 'node--packet',
					id: packetId,
					attributes: {
						field_packet_submitted: { value: true },
						field_submitted_on: { value: Math.floor(Date.now() / 1000) }
					}
				}
			},
			{
				headers: {
					Accept: 'application/vnd.api+json',
					'Content-Type': 'application/vnd.api+json'
				}
			}
		)
		.then(() => packetId)
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});
